module.exports = __webpack_public_path__ + "img/jianghaidong.325acddf.jpg";